import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Validators, FormGroup, FormControl } from '@angular/forms';
import { KeyValuePair, ValidationMessage } from '@tymes4-shared';

@Component({
    selector: 'app-add-discount-code-form',
    templateUrl: './add-discount-code-form.component.html',
    standalone: false
})
export class AddDiscountCodeFormComponent implements OnInit {

  validationMessages: KeyValuePair<ValidationMessage[]> = {};

  public form: FormGroup;

  constructor(@Inject(MAT_DIALOG_DATA) public passedData: any,
  public dialogRef: MatDialogRef<AddDiscountCodeFormComponent>) { }

  ngOnInit() {
    this.form = new FormGroup({
      DiscountCode: new FormControl('', [Validators.required, Validators.min(0)]),
    });
  }

  submit() {
    this.dialogRef.close(this.form.controls['DiscountCode']);
  }
}
